import { Grid } from '@mui/material'
import { LangSelectTextfieldContainer, LangSelectTextfieldInput } from '../styles/buttons'
import { availableLang } from '../models/Lang'
import { useTranslation } from 'react-i18next'
import FlagSelect from '../common/FlagSelect'
import React, { useEffect } from 'react'
import useDebouncedValue from '../hooks/useDebouncedValue'
import { MenuCategory } from '../models/MenuCategory'

type Props = {
    menuCategory: MenuCategory;
    setMenuCategory: (menuCategory: MenuCategory) => void;
    selectedLang: availableLang;
    setSelectedLang: (lang: availableLang) => void;
}

const LangSelectorTextfield = (props: Props) => {
    const { t } = useTranslation();
    const [editedTitle, setEditedTitle] = React.useState<string>(getCategoryTitle());
    useDebouncedValue(editedTitle, 800, handleCategoryTitleChange);

    useEffect(() => {
        const relevantTranslation = props.menuCategory.translations.find(
            t => t.isoCode.toLowerCase() === props.selectedLang
        );
        setEditedTitle(relevantTranslation?.title ?? '');
    }, [props.selectedLang])

    function getCategoryTitle(): string {
        const relevantTranslation = props.menuCategory.translations.find(translation => translation.isoCode.toLowerCase() === props.selectedLang);
        if (relevantTranslation) return relevantTranslation.title;
        return "";
    }

    function handleCategoryTitleChange(newTitle: string) {
        const relevantTranslation = props.menuCategory.translations.find(translation => translation.isoCode.toLowerCase() === props.selectedLang);
        if (!relevantTranslation) return;
        const newTranslation = {
            ...relevantTranslation,
            title: newTitle
        }
        if (relevantTranslation) {
            props.setMenuCategory({
                ...props.menuCategory,
                translations: props.menuCategory.translations.map(translation => translation.id === relevantTranslation.id ? newTranslation : translation)
            });
        }
    }

    return (
        <>
            <LangSelectTextfieldContainer>
                <Grid container>
                    <Grid item xs>
                        <LangSelectTextfieldInput
                            value={editedTitle}
                            onChange={(e) => setEditedTitle(e.target.value)}
                            placeholder={t("menu.no_category_name")}
                        />
                    </Grid>
                    <Grid item>
                        <FlagSelect
                            lang={props.selectedLang}
                            setLang={props.setSelectedLang}
                        />
                    </Grid>
                </Grid>
            </LangSelectTextfieldContainer>
        </>
    )
}

export default LangSelectorTextfield